import { render } from "./LoginPopup.vue?vue&type=template&id=87d47ef6&scoped=true&ts=true"
import script from "./LoginPopup.vue?vue&type=script&lang=ts"
export * from "./LoginPopup.vue?vue&type=script&lang=ts"

import "./LoginPopup.vue?vue&type=style&index=0&id=87d47ef6&lang=scss&scoped=true"

import exportComponent from "/var/www/kun/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87d47ef6"]])

export default __exports__